import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Ahora tengo mis propias verduras en casa.',
    author: 'María'
  }, {
    quote: 'Pensé que no podía… pero sí se puede.',
    author: 'Lucas'
  }, {
    quote: 'Es simple y práctico.',
    author: 'Carolina'
  }];
  return <section className="bg-white py-10 px-4 sm:px-6 lg:px-8" data-id="element-184">
      <div className="max-w-4xl mx-auto" data-id="element-185">
        <h2 className="font-serif text-3xl sm:text-4xl font-black text-center text-[#1A1A1A] mb-6" data-id="element-186">
          💬 Lo que dicen otras personas
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-187">
          {testimonials.map((t, index) => <div key={index} className="bg-neutral-bg rounded-2xl p-5 shadow-md border border-neutral-beige relative transition-all duration-300 hover:-translate-y-1 hover:shadow-xl group flex flex-col" data-id="element-188">
              <div className="absolute -top-3 left-4 text-4xl text-garden-light/30 font-serif font-black group-hover:text-garden-light/50 transition-colors leading-none" data-id="element-189">
                "
              </div>
              <div className="flex text-earth-accent text-xs mb-3 relative z-10" data-id="element-190">
                ★★★★★
              </div>
              <p className="text-gray-800 font-medium italic text-sm sm:text-base mb-4 leading-relaxed relative z-10 flex-grow" data-id="element-191">
                {t.quote}
              </p>
              <div className="pt-3 border-t border-neutral-beige/50" data-id="element-192">
                <p className="text-garden-dark font-bold text-xs uppercase tracking-wider" data-id="element-193">
                  — {t.author}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}